// promoción compra A y recibe descuento en B / promoción compra A y B, recibe descuento en ambos
import { useEffect, useState }  from 'react';

import ProductItem from '../Product/ProductItem';
import ProductSelect from '../Product/ProductSelect';

import { getTitle } from '../../../../helpers/admin/productHelper';
import { savePromoToBD } from '../../../../actions/admin/promotion';
import { basicMsg, confirmDialog } from '../../../../actions/swal_msg';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Grid, Stack, Button, Alert,
    TextField, ToggleButton, ToggleButtonGroup
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { regex_dec, regex_two_dec } from '../../../../constants/regex';
import { PROMO_PRODUCT } from '../../../../constants/shop/promotion/promotion_const';

const init = {
    label: 'Descuento (%)',
    maxLength: 5,
    helperText: '% de descuento',
    type: 'Descuento % en producto'
};

const PromoFour = ({
    today, promotion, allProducts,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion
}) => {
    const { promo, start_date, end_date } = promotion;

    const [data, setData] = useState(init);
    // tipo de descuento / longitud de campo
    const { label, maxLength, helperText, type } = data;

    // búsqueda de producto
    const [discount, setDiscount] = useState('');
    // tipo de descuento
    const [alignment, setAlignment] = useState('percentage');
    // producto A seleccionado
    const [productA, setProductA] = useState(PROMO_PRODUCT);
    // producto B seleccionado
    const [productB, setProductB] = useState(PROMO_PRODUCT);

    const { variant_id: variant_a_id } = productA;
    const { variant_id: variant_b_id, title, variant_title, price } = productB;

    const getDiscountTxt = () => {
        if (alignment === 'fixed')
            return {
                txt1: 'Descuento ($)',
                txt2: `$${discount} de descuento (después de IVA)`,
                txt3: `$${discount} de descuento`,
                max_length: 10
            };
        else if (alignment === 'percentage')
            return {
                txt1: 'Descuento (%)',
                txt2: `${discount}% de descuento`,
                txt3: `${discount}% de descuento`,
                max_length: 5
            };
        else
            return {
                txt1: 'Descuento (?)',
                txt2: 'descuento',
                txt3: 'descuento',
                max_length: 1
            };
    };

    const setTextData = () => {
        const { txt1, txt2, txt3, max_length } = getDiscountTxt();
        if (promo === 'CompraDescuento')
            setData(e => ({
                ...e, label: txt1,
                maxLength: max_length,
                helperText: txt2,
                type: `En compra de ${
                    variant_a_id ? getTitle(productA.title, productA.variant_title) : 'producto A'
                }, recibe ${txt3} de descuento en ${
                    variant_b_id ? getTitle(title, variant_title) : 'producto B'
                }`
            }));
        else if (promo === 'CompraABDescuento')
            setData(e => ({
                ...e, label: txt1,
                maxLength: max_length,
                helperText: txt2,
                type: `En compra de ${
                    variant_a_id ? getTitle(productA.title, productA.variant_title) : 'producto A'
                } y ${
                    variant_b_id ? getTitle(title, variant_title) : 'producto B'
                } recibe ${txt3} de descuento en ambos`
            }));
        else
            setData(e => ({
                ...e, label: 'X',
                maxLength: 1,
                helperText: `Descuento incorrecto`,
                type: 'No se reconoce tipo de descuento en producto'
            }));
    };
    
    useEffect(() => {
        setTextData();
    }, [promo, discount, productA, productB, alignment]);
    
    // producto buscando
    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'discount') {
            if (value === '' || regex_dec.test(value))
                setDiscount(value);
        }
    };

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null)
            setAlignment(newAlignment);
    };

    // productos A y B fueron seleccionados, se introdujo descuento
    const validation = () => {
        // valor de descuento a numérico
        const num = Number(discount);
        
        if (variant_a_id === '')
            basicMsg('Seleccione producto A');
        else if (variant_b_id === '')
            basicMsg('Seleccione producto B');
        else if (discount === '')
            basicMsg(alignment === 'fixed' ?
                'Seleccione la cantidad de descuento' :
                'Seleccione el porcentaje de descuento'
            );
        else if (alignment === 'percentage' && (num < 1 || num > 100))
            basicMsg('Porcentaje de descuento es incorrecto');
        else if (alignment === 'fixed') {
            // suma de precio de ambos productos
            const total = productA.price + price;
            if (!regex_two_dec.test(discount))
                basicMsg('Valor de descuento es incorrecto');
            // supera costo de producto B (el que recibe descuento)
            else if (promo === 'CompraDescuento' && num > price)
                basicMsg(`Descuento supera precio de ${getTitle(title, variant_title)}`);
            // supera costo de ambos productos
            else if (promo === 'CompraABDescuento' && num > total)
                basicMsg('Descuento supera precio de ambos productos combinados');
            else return true;
        } else return true;

        return false;
    };

    // verificar si productos tienen promoción
    const checkPromos = async () => {
        if (validation()) {
            // mismos productos seleccionados
            if (variant_a_id === variant_b_id) basicMsg('Producto A y B son iguales');
            else {
                const ActivePromotions = getProductPromotions(promo, activePromotion, otherPromotion, { productA, productB });
                if (ActivePromotions.status) {
                    if (await confirmDialog('¿Registrar la promoción?', ActivePromotions.html, 'Registrar'))
                        savePromo();
                } else savePromo();
            }
        }
    };

    // guardar promoción en BD
    const savePromo = async () => {
        const Model = {
            ...promotion,
            discount,
            discount_type: alignment,
            variant_a: {
                ...productA,
                _id: variant_a_id,
            },
            variant_b: {
                ...productB,
                _id: variant_b_id,
            },
        };
        const req = await savePromoToBD(Model, 'save-promo-four');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setProductA(PROMO_PRODUCT);
            setProductB(PROMO_PRODUCT);
            setDiscount('');
        }
    };

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        { `Promoción: ${type}` }
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    {
                        variant_a_id !== '' &&
                            <ProductItem
                                product={productA}
                                setProduct={setProductA}
                                alt={'producto-A'}
                                text={'Producto A seleccionado'}
                            />
                    }

                    {
                        variant_b_id !== '' &&
                            <ProductItem
                                product={productB}
                                setProduct={setProductB}
                                alt={'producto-B'}
                                text={'Producto B seleccionado'}
                            />
                    }
                </Grid>

                <ToggleButtonGroup
                    sx={{ mt: 2 }}
                    color="primary"
                    value={ alignment }
                    exclusive
                    onChange={ handleAlignment }
                    aria-label="discount"
                    >
                    <ToggleButton value="type" disabled>Tipo descuento</ToggleButton>
                    <ToggleButton value="percentage">%</ToggleButton>
                    <ToggleButton value="fixed">$</ToggleButton>
                </ToggleButtonGroup>

                <TextField fullWidth
                    sx={{ mt: 1 }}
                    name="discount"
                    label={ label }
                    variant="standard"
                    inputProps={{ maxLength }}
                    helperText={ helperText }
                    value={ discount }
                    onChange={ handleInputChange }
                />

                {
                    (variant_a_id !== '' && variant_b_id !== '') ?
                        <Button variant="contained"
                            onClick={ checkPromos }>
                            Guardar promoción
                        </Button>
                    :
                        <Alert severity="info" sx={{ mt: 2 }}>
                            Seleccione todos los productos para guardar la promoción
                        </Alert>
                }

                <ProductSelect
                    text={'Producto A'}
                    setProduct={ setProductA }
                    allProducts={allProducts}
                />

                <ProductSelect
                    text={'Producto B'}
                    setProduct={ setProductB }
                    allProducts={allProducts}
                />
            </Grid>
        </Grid>
    );
};

export default PromoFour;